// import config from 'config';
import { authHeader } from '../../_helpers';
import axios from 'axios';

export const demographicDataService = {
    addDemographicDataHandler,
    updateOrDeleteDemographicDataHandler,
};

axios.defaults.headers.common = authHeader();

function addDemographicDataHandler(data) {
    return axios.post('/masters/create/demographic/data/', data).then(response => {
        return response;
    });
}

function updateOrDeleteDemographicDataHandler(data, id, type) {
    if (type === 'edit') {
        return axios.put(`/masters/demographic/data/` + id + `/`, data).then(response => {
            return response;
        });
    }
    if (type === 'delete') {
        return axios.delete(`/masters/demographic/data/` + id + `/`, data).then(response => {
            return response;
        });
    }

}




// WEBPACK FOOTER //
// ./src/_services/demographicData/demographicData.service.js